import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/images/brands-bg/bycity_bg.png")